/**
 * VistoeraTASK-00670 — label for the team-management title plan badge.
 * Uses catalog plan_display_name only; never invents 免费版/标准版 from quotas.
 */

export type TeamPlanBadgeState = 'loading' | 'ready' | 'error' | 'missing' | 'orphan'

export function resolveTeamPlanBadge(input: {
  loading: boolean
  loadError: boolean
  planKey?: string | null
  planDisplayName?: string | null
}): { state: TeamPlanBadgeState; label: string } {
  const name = (input.planDisplayName || '').trim()
  if (name) return { state: 'ready', label: name }

  // Trusted name not yet available — never flash 套餐异常 while loading.
  if (input.loading) return { state: 'loading', label: '套餐加载中' }
  if (input.loadError) return { state: 'error', label: '套餐获取失败' }

  if (input.planKey) return { state: 'orphan', label: '套餐异常' }
  return { state: 'missing', label: '未配置' }
}
